import * as React from 'react'
import { TechnicalOrdersTodoFilters } from '@modules/technical-orders/technical-orders-todo/filters'
import { DateFromToInput } from '@modules/reports/user-reports/common/date-from-to-input'
import { ColAuto } from '@hyper/col-auto'
import { FormSelect } from '@hyper/forms/form-select'
import { TableFilters } from '@components/table/table'
import { guestsTechnicalOrderStatus } from '@modules/technical-orders/constants'

interface Props {
  filters: TableFilters
  setFilters: React.Dispatch<React.SetStateAction<TableFilters>>
  defaultFilters: TableFilters
}

export const ReceptionTechnicalOrdersFilters: React.FC<Props> = ({ filters, setFilters, defaultFilters }) => (
  <TechnicalOrdersTodoFilters
    hideLabel={false}
    filters={filters}
    searchClassName="ml-auto"
    setFilters={setFilters}
    defaultFilters={defaultFilters}
  >
    <DateFromToInput
      colSize={' '}
      className="col-auto"
      label="Data dodania"
      startDateName="created_after"
      endDateName="created_before"
    />
    <DateFromToInput
      colSize={' '}
      className="col-auto"
      label="Data zamknięcia"
      startDateName="finished_at_after"
      endDateName="finished_at_before"
    />
    <ColAuto>
      <FormSelect
        options={guestsTechnicalOrderStatus}
        name="status"
        label="Status"
        selectProps={{ isClearable: true, isSelectMulti: true }}
        formPlainProps={{ colStyle: { padding: 0, width: 200 } }}
      />
    </ColAuto>
  </TechnicalOrdersTodoFilters>
)
